// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_CUSTOM_SELECT_MATCH_ORDER = true;
